import { render, staticRenderFns } from "./RankingForm.vue?vue&type=template&id=673e9f9b&"
import script from "./RankingForm.vue?vue&type=script&lang=js&"
export * from "./RankingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports